export const PERMISSIONS = {
  // Member Portal
  MEMBER_PORTAL_ACCESS: "member-portal.access",

  // Invoices
  INVOICES_VIEW_LIST: "invoices.view-list",
  INVOICES_VIEW_DETAILS: "invoices.view-details",
  INVOICES_CREATE: "invoices.create",
  INVOICES_UPDATE: "invoices.update",
  INVOICES_DELETE: "invoices.delete",
  INVOICES_SEND: "invoices.send",

  // Recurring Invoices
  RECURRING_INVOICES_VIEW_LIST: "recurring-invoices.view-list",
  RECURRING_INVOICES_VIEW_DETAILS: "recurring-invoices.view-details",
  RECURRING_INVOICES_CREATE: "recurring-invoices.create",
  RECURRING_INVOICES_UPDATE: "recurring-invoices.update",
  RECURRING_INVOICES_DELETE: "recurring-invoices.delete",

  // Clients
  CLIENTS_VIEW_LIST: "clients.view-list",
  CLIENTS_VIEW_DETAILS: "clients.view-details",
  CLIENTS_CREATE: "clients.create",
  CLIENTS_UPDATE: "clients.update",
  CLIENTS_DELETE: "clients.delete",

  // Contacts
  CONTACTS_VIEW_LIST: "contacts.view-list",
  CONTACTS_VIEW_DETAILS: "contacts.view-details",
  CONTACTS_CREATE: "contacts.create",
  CONTACTS_UPDATE: "contacts.update",
  CONTACTS_DELETE: "contacts.delete",

  // Contact Types
  CONTACT_TYPES_VIEW_LIST: "contact-types.view-list",
  CONTACT_TYPES_CREATE: "contact-types.create",
  CONTACT_TYPES_UPDATE: "contact-types.update",
  CONTACT_TYPES_DELETE: "contact-types.delete",

  // Projects
  PROJECTS_VIEW_LIST: "projects.view-list",
  PROJECTS_VIEW_DETAILS: "projects.view-details",
  PROJECTS_CREATE: "projects.create",
  PROJECTS_UPDATE: "projects.update",
  PROJECTS_DELETE: "projects.delete",

  // Services
  SERVICES_VIEW_LIST: "services.view-list",
  SERVICES_VIEW_DETAILS: "services.view-details",
  SERVICES_CREATE: "services.create",
  SERVICES_UPDATE: "services.update",
  SERVICES_DELETE: "services.delete",

  // Time Entries
  TIME_ENTRIES_VIEW_LIST: "time-entries.view-list",
  TIME_ENTRIES_VIEW_DETAILS: "time-entries.view-details",
  TIME_ENTRIES_CREATE: "time-entries.create",
  TIME_ENTRIES_UPDATE: "time-entries.update",
  TIME_ENTRIES_DELETE: "time-entries.delete",

  // Admin Time Entries
  ALL_TIME_ENTRIES_VIEW_LIST: "all-time-entries.view-list",
  ALL_TIME_ENTRIES_CREATE: "all-time-entries.create",
  ALL_TIME_ENTRIES_UPDATE: "all-time-entries.update",
  ALL_TIME_ENTRIES_DELETE: "all-time-entries.delete",

  // Transactions
  TRANSACTIONS_VIEW_LIST: "transactions.view-list",
  TRANSACTIONS_VIEW_DETAILS: "transactions.view-details",
  TRANSACTIONS_CREATE: "transactions.create",

  // Taxes
  TAXES_VIEW_LIST: "taxes.view-list",
  TAXES_VIEW_DETAILS: "taxes.view-details",
  TAXES_CREATE: "taxes.create",
  TAXES_UPDATE: "taxes.update",
  TAXES_DELETE: "taxes.delete",

  // Surcharges
  SURCHARGES_VIEW_LIST: "surcharges.view-list",
  SURCHARGES_VIEW_DETAILS: "surcharges.view-details",
  SURCHARGES_CREATE: "surcharges.create",
  SURCHARGES_UPDATE: "surcharges.update",
  SURCHARGES_DELETE: "surcharges.delete",

  // Custom Fields
  CUSTOM_FIELDS_VIEW_LIST: "custom-fields.view-list",
  CUSTOM_FIELDS_VIEW_DETAILS: "custom-fields.view-details",
  CUSTOM_FIELDS_CREATE: "custom-fields.create",
  CUSTOM_FIELDS_UPDATE: "custom-fields.update",
  CUSTOM_FIELDS_DELETE: "custom-fields.delete",

  // Forms
  FORMS_VIEW_LIST: "forms.view-list",
  FORMS_VIEW_DETAILS: "forms.view-details",
  FORMS_CREATE: "forms.create",
  FORMS_UPDATE: "forms.update",
  FORMS_DELETE: "forms.delete",

  // Contracts
  CONTRACTS_VIEW_LIST: "contracts.view",
  CONTRACTS_VIEW_DETAILS: "contracts.view",
  CONTRACTS_CREATE: "contracts.create",
  CONTRACTS_EDIT: "contracts.edit",
  CONTRACTS_DELETE: "contracts.delete",

  // Team Members
  TEAM_MEMBERS_VIEW_LIST: "team-members.view-list",
  TEAM_MEMBERS_VIEW_DETAILS: "team-members.view-details",
  TEAM_MEMBERS_INVITE: "team-members.invite",
  TEAM_MEMBERS_UPDATE: "team-members.update",
  TEAM_MEMBERS_DEACTIVATE: "team-members.deactivate",

  // Billing
  BILLING_VIEW: "billing.view",
  BILLING_MANAGE: "billing.manage",

  // Organization
  ORGANIZATION_VIEW: "organization.view",
  ORGANIZATION_UPDATE: "organization.update",
  ORGANIZATION_DELETE: "organization.delete",

  // Advanced Organization Settings (mail domain, compliance address)
  ADVANCED_ORG_SETTINGS_VIEW: "advanced-organization-settings.view",
  ADVANCED_ORG_SETTINGS_MANAGE: "advanced-organization-settings.manage",

  // Notification Routing
  NOTIFICATION_ROUTING_VIEW: "notification-routing.view",
  NOTIFICATION_ROUTING_MANAGE: "notification-routing.manage",

  // Owner
  OWNER_MANAGE: "owner.manage",

  // Integrations
  INTEGRATIONS_VIEW: "integrations.view",
  INTEGRATIONS_MANAGE: "integrations.manage",

  // Expenses
  EXPENSES_VIEW: "expenses.view",
  EXPENSES_CREATE: "expenses.create",
  EXPENSES_EDIT: "expenses.edit",
  EXPENSES_DELETE: "expenses.delete",
  EXPENSES_MANAGE: "expenses.manage",

  // Reports
  REPORTS_VIEW: "reports.view",

  // My Time Reports
  MY_TIME_REPORTS_VIEW: "my-time-reports.view",

  // Report Subscriptions
  REPORT_SUBSCRIPTIONS_VIEW: "report-subscriptions.view",
  REPORT_SUBSCRIPTIONS_MANAGE: "report-subscriptions.manage",

  // Audit Logs
  AUDIT_LOGS_VIEW: "audit-logs.view",
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
